import e from"slugify";e.extend({".":"+"}),e.extend({"/":"+"}),e.extend({"\\":"+"}),e.extend({"%":""});var t=(t="",r=!0)=>e(t,{lower:r,replacement:"+",strict:!0});export{t as default};
